<div class="loading-container" *ngIf="isLoading" [class.contained]="mode === 'contained'">
  <svg class="loading-spinner" [class]="'loading-spinner--' + size" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
    <g transform="translate(8, 0)"> <path d="M8 19c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.345 3 3-1.345 3-3 3zm0-8C5.243 11 3 13.243 3 16s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5z"></path>
      <g id="loading-blades">
        <path d="M19.182 6.232L14.233 11.182 12.818 9.767 17.768 4.817z"></path>
        <path d="M15 17h6v-2h-6z"></path>
        <path d="M7 9h2V3H7z"></path>
      </g>
    </g>
  </svg>
  <p class="loading-text" *ngIf="showText && text">{{ text }}</p>
</div>